import React from "react";
import CollapsibleArea from "../common/CollapsibleArea";

interface IProps {
    state: string,
    reference: any,
    profitCenters: EventDictionary<boolean>,
    users: EventDictionary<{
        name: string;
        ProfitCenterId: number;
    }>,
    checked: EventDictionary<boolean>,
    change: (user: string) => void,
    startOpen?: boolean,
    onToggle?: () => void
}
interface EventDictionary<TValue>{
    [id: string]: TValue
  }
const CalendarStateCollapse: React.FC<IProps> = (props: IProps) => {

    const profitChange = (id:number, bool:boolean) => {
        Object.keys(users).forEach((userid:string) => {  
            if(users[userid].ProfitCenterId === id && bool === checked[userid]){
                change(userid)
            }
        })
    }

    const {state, reference, profitCenters, users, checked, change} = props
    let count = 0
    let profitCounts:EventDictionary<number>= {}
    let usersSort = Object.keys(users).sort((a,b) => users[a].name>users[b].name?1:-1)
    let dropDown = reference.profitCenters.map((i:any) =>{
        profitCounts[`${i.id}`] = 0

        return (
            profitCenters[`${i.id}`]!==undefined&&Object.keys(profitCenters).indexOf(`${i.id}`)>-1&&Object.values(users).filter((user) => user.ProfitCenterId ===i.id).length>0?
            (
                <CollapsibleArea key={i.id} // Ledger Table
                Toggle={({ onClick, open }: any) => {
                    return (
                        <tr key={i.id}
                            tabIndex={0}
                            role="button"
                            onClick={onClick}
                            onKeyDown = {e => {
                                if (e.key === "Enter" || e.key === " ") {
                                    onClick(e);
                                    e.preventDefault();
                                }
                            }}
                            >
                            <td style={{paddingLeft: "15px"}}><i onClick={onClick} className="material-icons mr-1 action-text">{open ? "remove_circle_outline" : "add_box"}</i>{i.name} {profitCounts[`${i.id}`]}</td>
                            <td><input type="checkbox" checked={profitCenters[`${i.id}`]} onChange={() => profitChange(i.id, profitCenters[`${i.id}`])}/></td>
                        </tr>
                    );
                } }
                startOpen={props.startOpen ?? false}>{
                    usersSort.map((j:string) => { 
                        return (
                            users[j].ProfitCenterId===i.id?
                            users[j].name.indexOf("(")>-1?
                            ( 
                                count++,
                                profitCounts[`${i.id}`]++,
                                (<tr key = {j}>
                                    <td style={{paddingLeft: "30px"}}>{users[j].name.substring(0, users[j].name.indexOf("("))}</td>
                                    <td><input type="checkbox" checked={checked[j]} onChange={() => change(j)}/></td>
                                </tr>)):
                        ( 
                            count++,
                            profitCounts[`${i.id}`]++,
                            (<tr key = {j}>
                            <td style={{paddingLeft: "30px"}}>{users[j].name}</td>
                            <td><input type="checkbox" checked={checked[j]} onChange={() => change(j)}/></td>
                        </tr>))
                        :null
                        );
                    })
                }</CollapsibleArea>
            )
            :null
        )
        })
    return(
        
        <>
            {
                count>0?
                <CollapsibleArea // Ledger Table
                Toggle={({ onClick, open }: any) => {
                    return (
                            <tr className="stateContent"
                                tabIndex={0}
                                role="button"
                                onClick={onClick}
                                onKeyDown={e => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        onClick(e);
                                        e.preventDefault();
                                    }
                                }}
                            >
                                <th className="d-flex align-items-center">
                                    <i onClick={onClick} className="material-icons mr-1 action-text">{open ? "remove_circle_outline" : "add_box"}</i>
                                    {state} {count}
                                </th>
                                <th>
                                </th>
                            </tr>
                    );
                } }
                startOpen={props.startOpen ?? false}>
                            {dropDown}
                    </CollapsibleArea>:null
            }
        </>

        
    )
}
export default CalendarStateCollapse